import { Accordion, Button, Col, Container, Dropdown, Row } from "react-bootstrap";
import { formatDate } from "../../../../Utils/Common";
import DetailItem from "../DataItem"
import { SampleService } from "../../../../Services/Sample.service";
import { useEffect, useState } from "react";
import CollectSampleNote from "./CollectSampleNote";
import DonorDemographicsList from "./DonorDemographicsList";
import { SampleRequestService } from "../../../../Services/SampleRequest.Service";
import HealthDataDownloadButton from "./HealthDataDownloadButton";

const BloodSampleAccordion = ({ id, sampleRequestDetails,recruitedDonor, isCollectSample, isMatched ,selectedRecruitedDonor, collectSample, type, raceList}) => {
    const tubeTypeLabels = {
        bluetoptubenumberoftubes: { label: "Blue Top (Citrated)", size: "4.5 mL" },
        redtoptubenumberoftubes: { label: "Red Top (no additive)", size: "10 mL" },
        marbletoptubenumberoftubes: { label: "Marble Top (SST)", size: "8.5 mL" },
        purpletoptubenumberoftubes: { label: "Purple Top (EDTA) (K2)", size: "4 mL" },
        purpletoptube1numberoftubes: { label: "Purple Top (EDTA) (K2)", size: "10 mL" },
        greentoptubenumberoftubes: { label: "Green Top (Heparinized)", size: "4 mL" },
        greentoptube1numberoftubes: { label: "Green Top (Heparinized)", size: "10 mL" },
        heparincellpreptubenumberoftubes: { label: "Heparin Cell Prep (CPT)", size: "8 mL" },
        citratecellpreptubenumberoftubes: { label: "Citrate Cell Prep (CPT)", size: "8 mL" },
        yellowtoptubenumberoftubes: { label: "Yellow Top (ACD)", size: "8.5 mL" },
        paxgenetubenumberoftubes: { label: "PAXgene Tube", size: "2.5 mL" },
        // bloodfingerpricktype: { label: "Finger Prick", size: "Not Specified" },
    };



    const [additionalSticks, setAdditionalSticks]=useState(null);
    const [collectSampleNote, setCollectSampleNote]=useState("");
    const [isCollect, setIsCollect]=useState(false);

    useEffect(() => {
        if (selectedRecruitedDonor) { 
            const donatedSamplesArray = selectedRecruitedDonor?.donated_samples
                ?.split(',')
                .map((sample) => sample.trim()); // Split and trim whitespace
    
            if (donatedSamplesArray?.includes(id.toString())) {
                setAdditionalSticks(selectedRecruitedDonor?.additional_sticks);
                // setCollectSampleNote(selectedRecruitedDonor?.collected_notes);
                const notesArray = selectedRecruitedDonor?.collected_notes?.split(',').map((note) => note.trim());
                const noteIndex = selectedRecruitedDonor?.donated_samples
                    ?.split(',')
                    .map((sample) => sample.trim())
                    .indexOf(id.toString());
                    if(notesArray){ 
                        setCollectSampleNote(noteIndex !== -1 ? notesArray[noteIndex] : "");
                    }
            }
            else{
                setAdditionalSticks("");
                setCollectSampleNote("");
            }
        }
        else{
            setAdditionalSticks("");
            setCollectSampleNote("");
        }
    }, [selectedRecruitedDonor, id]);
    
    useEffect(()=>{
        if(isCollect){            


            const collectSamplePayload = { 
                sample_id : id,
                collection_note : collectSampleNote,
                additional_sticks : additionalSticks,
            }

            collectSample(collectSamplePayload);
            setIsCollect(false);
        }
    },[isCollect]);
     
    return (
        <Accordion.Item eventKey="9">
           
            <Accordion.Header>
                <div className="text-white bg-danger el-sample-btn btn rounded p-2">
                    <i className="el-icon-blood "></i> Blood 
                </div>
                {
                    selectedRecruitedDonor?.donated_samples
                        ?.split(',')
                        .map((sample) => sample.trim())
                        .includes(id.toString()) && (
                        <>
                            <div className="text-white bg-success el-sample-btn btn rounded p-2 ms-2">
                            <i className="el-icon-check"></i> Collected
                            </div>
                        </>
                    )
                }

                
            </Accordion.Header>
            <Accordion.Body>
                <div className="el-property-details-card-content">
                    <Row>
                        <Col md={12} className="mx-fit-content">
                            <div className="flex-sec justify-content-between align-items-start">
                                {/* Sample Expiration Date */}
                                {/* <DetailItem
                                    title="Sample’s Expiration Date"
                                    detail={formatDate(
                                        sampleRequestDetails.expiration_date || ''
                                    )}
                                /> */}
                                <DetailItem
                                    title="Sample can remain unprocessed"
                                    detail={`${sampleRequestDetails.unprocess_number} ${sampleRequestDetails.unprocess_unit[0].toUpperCase() + sampleRequestDetails.unprocess_unit.slice(1)}` || ''}
                                />
                                {/* Is Fasting Required */}
                                <DetailItem
                                    title="Is Fasting Required?"
                                    detail={
                                        sampleRequestDetails?.is_fasting === 1
                                            ? `Yes - ${sampleRequestDetails?.fasting_duration || ''} ${sampleRequestDetails?.fasting_unit ? (sampleRequestDetails.fasting_unit[0].toUpperCase() + sampleRequestDetails.fasting_unit.slice(1)) : ''}`
                                            : 'No'
                                    }
                                />

                                {/* Tube Type(s) */}

                                <DetailItem
                                    title="Tube Type(s)"
                                    detail={sampleRequestDetails.samples_info
                                        .filter((tube) => tube.field_name.endsWith("numberoftubes")) // Filter for type fields
                                        .map((tube, index) => {
                                            const readableLabel = tubeTypeLabels[tube.field_name];
                                            if(tube.field_value){
                                                return (
                                                    <p  key={`gender-${index}`} className="el-request-detail-profile-name">
                                                        {readableLabel
                                                            ? `${readableLabel.label} - ${readableLabel.size} -${tube.field_value} ${tube.field_value > 1 ? 'tubes' : 'tube'} `
                                                            : ``}                                                        
                                                    </p>
                                                );
                                            }                                            
                                        })}
                                />
                                 {/* Number of Finger Prick’s  */}
                                 {sampleRequestDetails.samples_info.find(
                                    (info) => info.field_name === "bloodfingerpricktype"
                                )?.field_value && (
                                        <DetailItem
                                            title="No of Finger Pricks"
                                            detail={
                                                `${sampleRequestDetails.samples_info.find(
                                                    (info) =>
                                                        info.field_name === "bloodfingerpricknumberoftubes"
                                                )?.field_value} drops` || "Not Specified"
                                            }
                                           
                                        />
                                    )}

                                {/* Finger Prick’s Preferred Blood Collection Manufacturer */}
                                {/* {sampleRequestDetails.samples_info.find(
                                    (info) => info.field_name === "bloodfingerpricktype"
                                )?.field_value && ( */}
                                        <DetailItem
                                            title="Finger Prick’s Preferred Blood Collection Manufacturer"
                                            // detail={
                                            //     sampleRequestDetails.samples_info.find(
                                            //         (info) =>
                                            //             info.field_name === "bloodfingerpricknumberoftubes"
                                            //     )?.field_value || "Not Specified"
                                            // }
                                            detail={
                                                sampleRequestDetails.samples_info.find(
                                                    (info) =>
                                                        info.field_name === "bloodfingerpricknote"
                                                )?.field_value || ""
                                            }
                                        />
                                    {/* )} */}
                                     <div className="el-flex-area mb-3">

                                        {(!isCollectSample && type ==='requestor' ) && (
                                            <> 
                                    <div className="el-content-detail d-block">
                                        <div>   
                                        <DetailItem
                                            title="Number of Sticks" 
                                            detail={
                                                recruitedDonor?.map((donor) => donor.additional_sticks)  
                                                  .find((stick) => stick !== null) || ""  
                                              }
                                        />
                                        </div></div>     </>
                                        )}
                                        </div>
                                {/* Donor ID */}

                                {!isCollectSample && (
                                            <>
                                <div className="el-flex-area mb-3">
                                    <div className="el-content-detail d-block">
                                        <div>   
                                        <DetailItem
                                            title="Special Donor Requests" 
                                            detail= {sampleRequestDetails.is_special_donor == 1 ? 'Yes' : 'No'}
                                        />
                                            {/* <p className="el-request-detail-profile-title">
                                                Special Donor Requests:
                                            </p>
                                            <h4 className="el-request-detail-profile-name">
                                                {sampleRequestDetails.is_special_donor == 1 ? 'Yes' : 'No'}
                                            </h4> */}
                                        </div>
                                        {sampleRequestDetails.is_special_donor == 1 && (<>
                                            <p className="el-request-detail-profile-title">
                                                Preferred donor ID:
                                            </p>
                                            <h4 className="el-request-detail-profile-name">
                                                {JSON.parse(sampleRequestDetails.special_donor_ids)?.map(
                                                    (donor, index) => (
                                                        <p key={index}>
                                                            {/* {index + 1}. Donor ID: {donor} */}
                                                            {index + 1}. Donor ID: {donor}, { sampleRequestDetails.special_donor_ids_gender[index]}
                                                        </p>
                                                    )
                                                )}
                                                {JSON.parse(sampleRequestDetails.special_donor_gender)?.map(
                                                    (donor, index) => (
                                                        <p key={index}>
                                                            {(JSON.parse(sampleRequestDetails.special_donor_ids)
                                                                ?.length  || 0) + index + 1}
                                                            . Donor ID: {donor},{" "}
                                                            {JSON.parse(sampleRequestDetails.special_donor_gender)[
                                                                index
                                                            ] === "XX"
                                                                ? `Female (${JSON.parse(
                                                                    sampleRequestDetails.special_donor_gender_quantity
                                                                )[index]
                                                                })`
                                                                : `Male (${JSON.parse(
                                                                    sampleRequestDetails.special_donor_gender_quantity
                                                                )[index]
                                                                })`}
                                                        </p>
                                                    )
                                                )}
                                            </h4>
                                      
                                            {/* <p className="el-request-detail-profile-title">
                                                Alternate Donor ID:
                                            </p>
                                            <h4 className="el-request-detail-profile-name">
                                                {JSON.parse(sampleRequestDetails.alternate_donor_ids)?.map(
                                                    (donor, index) => (
                                                        <p key={index}>
                                                            {index + 1}. Donor ID: {donor}, {sampleRequestDetails.alternate_donor_ids_gender[index] }

                                                        </p>
                                                    )
                                                )}
                                                {JSON.parse(sampleRequestDetails.alternate_donor_gender)?.map(
                                                    (donor, index) => (
                                                        <p key={index}>
                                                            {(JSON.parse(
                                                                sampleRequestDetails.alternate_donor_ids
                                                            )?.length  || 0)  +
                                                                index +
                                                                1}
                                                            . Donor ID: {donor},{" "}
                                                            {JSON.parse(sampleRequestDetails.alternate_donor_gender)[
                                                                index
                                                            ] === "XX"
                                                                ? `Female (${JSON.parse(
                                                                    sampleRequestDetails.alternate_donor_gender_quantity
                                                                )[index]
                                                                })`
                                                                : `Male (${JSON.parse(
                                                                    sampleRequestDetails.alternate_donor_gender_quantity
                                                                )[index]
                                                                })`}
                                                        </p>
                                                    )
                                                )}
                                            </h4> */}
                                            <DonorDemographicsList 
                                            sampleRequestDemographics={sampleRequestDetails.sample_request_demographics}
                                            raceList={raceList}
                                            />
                                            </>)}
                                        
                                    </div>
                                </div>
                                </>)}

                                {/* Special Instructions */}
                                <DetailItem
                                    title="Special Instructions"
                                    detail={sampleRequestDetails.instruction  || '-'}
                                />
                                {/* <p className="el-request-detail-profile-title">
                                    Recruited Donor:
                                </p> */}


                                {!isCollectSample && type !== 'requestor' && recruitedDonor?.length > 0 && !isMatched && (
                                    <>
                                        <DetailItem
                                            title="Recruited Donors"
                                        />
                                        <h4 className="el-request-detail-profile-name">
                                            {recruitedDonor.map((donorItem, index) => (
                                                <div key={index} className="d-flex align-items-center justify-content-between mb-2">
                                                    {`${index + 1}. Donor ID: ${donorItem?.donor?.donor_id}. ${donorItem?.donor?.gender === 'XY' ? 'Male' : 'Female'} (${donorItem?.donor?.gender})`}
                                                    <HealthDataDownloadButton requestId={sampleRequestDetails.request_id} donorId={donorItem.donor.id}></HealthDataDownloadButton>
                                                   
                                                </div>
                                            ))}
                                        </h4>
                                    </>
                                )}

                                {isCollectSample === true && (
                                <>
                                    <DetailItem
                                    title="Additional Stick(s)"
                                    />
                                    <select
                                        as="select"
                                        name="additional_sticks"
                                        className="form-control"
                                        value={additionalSticks}
                                        onChange={(e) => { 
                                            setAdditionalSticks(e.target.value);
                                        }}
                                    >
                                        <option value="">Select # of sticks</option>
                                        {[1,2,3,4].map((stick) => (
                                            <option key={stick}   value={stick}>{stick}</option>
                                        ))}
                                    </select>
                                        {selectedRecruitedDonor && (
                                            <>
                                                <CollectSampleNote sampleRequestDetails={sampleRequestDetails}  collectSampleNote={collectSampleNote} setCollectSampleNote={setCollectSampleNote} isCollect={isCollect} setIsCollect={setIsCollect} selectedRecruitedDonor={selectedRecruitedDonor} id={id}/>
                                            </>
                                        )}
                                </>
                                )}

                            </div>
                        </Col>
                    </Row>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default BloodSampleAccordion; 